import i18n from 'i18next';

export enum SystemMode {
  HOME, AWAY, SLEEP
}

export function systemModeToString(target: SystemMode): string {
  switch(target) {
    case SystemMode.HOME:
      return i18n.t('Home');
    case SystemMode.AWAY:
      return i18n.t('Away');
    case SystemMode.SLEEP:
      return i18n.t('Sleep');
  }
}
